import React from 'react'
import { Row, Col } from 'rsuite'
import InputForm from '../../../components/forms/input/InputForm'
import InputCascaderForm from '../../../components/forms/input/InputCascaderForm'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import InputRadioForm from '../../../components/forms/input/InputRadioForm'
import InputDateForm from '../../../components/forms/input/InputDateForm'
import UploaderForm from '../../../components/forms/input/UploaderForm'

export default function RenderInputWidget({
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  cascaderDatas,
  inputs,
}) {
  return (
    <Row>
      {inputs.map((item) => {
        let inputObj
        switch (item.type) {
          case 'INPUT':
            inputObj = (
              <InputForm
                schema={item}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            )
            break
          case 'INPUT_NUMBER':
            inputObj = (
              <InputForm
                schema={item}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                isInputNumber
              />
            )
            break
          case 'INPUT_AREA':
            inputObj = (
              <InputForm
                schema={item}
                rows={4}
                componentClass="textarea"
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            )
            break
          case 'DOPDOWN':
            inputObj = (
              <InputSelectForm
                schema={item}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            )
            break
          case 'RADIO':
            inputObj = (
              <InputRadioForm
                schema={item}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            )
            break
          case 'CASCADER':
            inputObj = (
              <InputCascaderForm
                schema={item}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            )
            break
          case 'lOCATION_CASCADER':
            inputObj = (
              <InputCascaderForm
                schema={item}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                cascaderDatas={cascaderDatas}
              />
            )
            break
          case 'DATE':
            inputObj = (
              <InputDateForm
                schema={item}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            )
            break
          case 'UPLOAD':
            inputObj = (
              <UploaderForm
                schema={item}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            )
            break
          case 'SINGLE_UPLOAD':
            inputObj = (
              <UploaderForm
                schema={item}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                single={true}
              />
            )
            break
          case 'LABEL':
            inputObj = (
              <div style={{ marginTop: 10 }}>
                <strong>{item.label}</strong>
              </div>
            )
            break
          default:
            break
        }

        return (
          <Col xs={24} sm={24} md={item.sizeMdLg || 24} lg={item.sizeMdLg || 24}>
            {inputObj}
          </Col>
        )
      })}
    </Row>
  )
}
